import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import useCheckAuthToken from '../Hooks/useCheckAuthToken';
import { ROUTE_CONFIG } from '../components/NavBar/MenuItems';


export default function PrivateRoute() {
  const isAuthenticated = useCheckAuthToken();
  const location = useLocation();

  const user = useSelector((state: any) => state.user?.user);
  const scope = user?.scope;
  const category = user?.category;

  const route = ROUTE_CONFIG.find((r) => r.path === location.pathname);

  if (!scope || !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (route && !route.canAccess(scope, category)) {
    return <NotFound />;
  }

  return <Outlet />;
}